// extracted by mini-css-extract-plugin
module.exports = {"root":"PageTitle_root__NxeGq","wrapper":"PageTitle_wrapper__Uo_Do","title":"PageTitle_title__DKkab"};